import { useParams } from 'react-router-dom'
import { useMemo } from 'react'

import { Loading } from 'ui/Loading/Loading'
import { useCategoryQuery } from 'features/categories/hooks'
import { useAuthStore } from 'features/auth/useAuthStore'
import { useSoftwareListQuery } from 'features/software/hooks'
import { SoftwareList } from 'features/software/SoftwareList/SoftwareList'
import type { SoftwareListSchema } from 'openapi'

type Props = {
  className?: string
  categoryId?: number
}

export const CategoryPage = (props: Props) => {
  const params = useParams()
  const isStaff = useAuthStore((s) => s.user?.isStaff)

  const categoryId = (props.categoryId ?? params.categoryId) ? Number(params.categoryId) : undefined
  if (categoryId === undefined) throw new Error('No category id provided')

  const { isLoading: isCategoryLoading, data: category } = useCategoryQuery(categoryId)
  const { isLoading: isSoftwareListLoading, data: softwareListResult } = useSoftwareListQuery({
    categoryIn: [categoryId],
  })
  const softwareList: SoftwareListSchema[] = useMemo(() => softwareListResult ?? [], [softwareListResult])

  const enabledSoftware = useMemo(() => softwareList.filter((s) => s.status === 'enabled'), [softwareList])
  const disabledSoftware = useMemo(() => softwareList.filter((s) => s.status !== 'enabled'), [softwareList])

  if (isCategoryLoading || isSoftwareListLoading) return <Loading />

  return (
    <div className="h-full space-y-2">
      {/*<div className="mb-4">*/}
      {/*  <CategoryPageBreadcrumb categoryId={categoryId} />*/}
      {/*</div>*/}

      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-light grow">{category?.name}</h1>
      </div>

      <SoftwareList software={enabledSoftware} />

      {/* ENABLED */}
      {/*{categoryWithChildren ? <CategorySoftwareList category={categoryWithChildren} enabled /> : null}*/}

      {/* DISABLED */}
      {isStaff && disabledSoftware.length ? (
        <>
          <div className="flex items-center justify-center w-full">
            <hr className="w-64 h-px my-8 bg-gray-200 border-0" />
            <span className="px-3 text-gray-400">Disabled</span>
            <hr className="w-64 h-px my-8 bg-gray-200 border-0" />
          </div>
          <div>
            <SoftwareList software={disabledSoftware} />
          </div>
        </>
      ) : null}
    </div>
  )
}

// const CategoryPageBreadcrumb = (props: { categoryId: number }) => {
//   const parentCategories = useParentCategories(props.categoryId)
//   const crumbs = useMemo<Crumb[]>(() => {
//     return parentCategories.map((cat: CategorySchema, i: number) => {
//       const last = i === parentCategories.length - 1
//       return {
//         label: cat.name,
//         href: last ? CategoryRoutePath({ categoryId: cat.id }) : null,
//       }
//     })
//   }, [parentCategories])
//   return <BreadCrumbs crumbs={crumbs} />
// }
